"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_chartjs_2_1 = require("react-chartjs-2");
var chart_js_1 = require("chart.js");
var theme_1 = require("../../theme");
require("moment/locale/de");
require("chartjs-adapter-moment");
chart_js_1.Chart.register(chart_js_1.CategoryScale, chart_js_1.LinearScale, chart_js_1.BarElement, chart_js_1.LineElement, chart_js_1.BarController, chart_js_1.Tooltip, chart_js_1.TimeScale);
var tooltipDataFormat = {
    minutes_1: 'HH:mm - dd Do MMM YYYY',
    minutes_5: 'HH:mm - dd Do MMM YYYY ',
    hour: 'HH:mm - dd Do MMM YYYY ',
    day: 'dd Do MMM YYYY',
    month: 'MMMM YYYY',
    year: 'YYYY'
};
var prepositionDates = {
    minutes_1: function (d) {
        d.setMilliseconds(0);
        d.setSeconds(0);
        return d;
    },
    minutes_5: function (d) {
        d.setMilliseconds(0);
        d.setSeconds(0);
        return d;
    },
    hour: function (d) {
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setMinutes(0);
        return d;
    },
    day: function (d) {
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setHours(0);
        return d;
    },
    month: function (d) {
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setMinutes(0);
        d.setHours(0);
        d.setDate(1);
        return d;
    },
    year: function (d) {
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setMinutes(0);
        d.setHours(0);
        d.setDate(1);
        d.setMonth(0);
        return d;
    },
};
var BarChart = function (_a) {
    var data = _a.data, _b = _a.timeUnit, timeUnit = _b === void 0 ? "hour" : _b, _c = _a.height, height = _c === void 0 ? 500 : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? theme_1.colors.primary : _d;
    var prepositionDatesFunction = prepositionDates[timeUnit];
    var chartData = data.map(function (_a) {
        var date = _a.date, hits = _a.hits;
        return ({ x: prepositionDatesFunction(date), y: hits });
    });
    return ((0, jsx_runtime_1.jsx)(react_chartjs_2_1.Bar, { height: height, data: {
            datasets: [{
                    data: chartData,
                    backgroundColor: backgroundColor,
                }]
        }, options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    type: 'time',
                    time: {
                        unit: timeUnit == "minutes_5" || timeUnit === "minutes_1" ? "minute" : timeUnit,
                        tooltipFormat: tooltipDataFormat[timeUnit],
                        stepSize: timeUnit == "minutes_5" ? 5 : 1,
                        displayFormats: {
                            minute: "HH:mm",
                            hour: "HH",
                            month: "MMM YYYY",
                        },
                    },
                    grid: {
                        display: false,
                    }
                },
                y: {
                    beginAtZero: true,
                },
            },
            plugins: {
                legend: {
                    display: false,
                },
            }
        } }));
};
exports.default = BarChart;
